import React from 'react';
import PropTypes from 'prop-types';
import { TextAreaField } from '@cgn/framework-ui-components/v2';
import useRequiredField from './useRequiredField';

export default function Messaggio({ value, onChange }) {
  const {
    text, state, stateMessage, onChange: handleOnChange,
  } = useRequiredField(value, onChange);
  return (
    <TextAreaField
      value={text}
      className="helpdesk-frontend-scelta-servizio__form-item helpdesk-frontend-questionario__messaggio"
      title="Scrivi qui il tuo messaggio*"
      onChange={handleOnChange}
      state={state}
      stateMessage={stateMessage}
    />
  );
}

Messaggio.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
